import type { ReactNode } from 'react';
import { cn } from '@/shared/utils/cn';
import { DomainIcon } from '../icons/DomainIcon';
import { isDomainIconId } from '../icons/domainIconTypes';

export interface EmptyStateProps {
  /** Id de un icono de dominio (vaca, pizarra…) o un nodo propio. */
  icon?: string | ReactNode;
  title: string;
  description?: string;
  /** Una acción clara: qué hacer para salir del vacío. */
  action?: ReactNode;
  compact?: boolean;
  className?: string;
}

/** Estado vacío con guía: dice qué pasa y qué hacer. El icono va en un círculo punteado, como trazado a tiza. */
export function EmptyState({
  icon = 'pizarra',
  title,
  description,
  action,
  compact = false,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-3 px-6 text-center',
        compact ? 'py-8' : 'py-12 md:py-16',
        className,
      )}
    >
      <div className="grid size-16 place-items-center rounded-full border border-dashed border-input bg-muted text-fg-muted">
        {typeof icon === 'string' && isDomainIconId(icon) ? (
          <DomainIcon id={icon} size={32} />
        ) : (
          icon
        )}
      </div>
      <h2 className="font-display text-xl font-bold text-fg">{title}</h2>
      {description ? <p className="max-w-sm text-base text-fg-muted">{description}</p> : null}
      {action ? <div className="mt-1">{action}</div> : null}
    </div>
  );
}
